import { FC } from "react";
import styles from "./Hero.module.scss";
import cn from "classnames";
import { Link } from "react-router-dom";

const Hero: FC = () => (
    <section className={styles.hero}>
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.text}>
                    <div className={styles.badge}>
                        <img width={24} height={24} src="/images/home/hero/toncoin.svg" alt="" />
                        <span>TON Blockchain</span>
                    </div>
                    <h1 className={styles.headline}>
                        Join the next level <br /> of crypto exchanger
                    </h1>
                    <p className={styles.description}>
                        Exchange tokens thanks to convenient swap and fast features in the TON blockchain
                    </p>
                    <div className={styles.buttons}>
                        <Link to="/swap" className={cn(styles.button, styles.primary)}>
                            <span>Launch app</span>
                            <img width={10} height={10} aria-hidden="true" src="/images/home/hero/arrow.svg" alt="" />
                        </Link>
                        <a href="#offers" className={cn(styles.button, styles.secondary)}>
                            More
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <picture>
            <source srcSet="/images/home/hero/nest3d2x.png" media="(min-resolution: 2dppx)" />
            <img
                className={styles.image}
                aria-hidden="true"
                width={530}
                height={586}
                src="/images/home/hero/nest3d.png"
                alt=""
            />
        </picture>
    </section>
);

export default Hero;
